<template>
	<main class="main_container" style="background-color: #414141;flex-wrap: wrap;">
		<div class="menu">
			<div class="menu-item" style="padding-top: 3em;padding-bottom: 2em;">
				<h3 style="font-size: 25px;">Application Field</h3>
				<div class="row">
					<div class="col">
						<a href="#" class="btn" style="padding: 0.05rem 4.5rem;background-color: #FCB42E;"></a>
					</div>
				</div>
			</div>
		</div>
		<div class=" photo-group mt-4">
			<!-- 每张图片 -->
			<div class="photo-container" v-for="(item, index) in field" :key="index" @click="getVlogData(item.id)">
				<img class="default-img" :src="item.url" alt="默认图片1" loading="lazy" >
				<div class="photo-title">{{ item.name }}</div>
			</div>
		</div>
		<section class="container mt-4">
			<div class="row" data-aos="fade-up">
				<div class="col-md-4 content_padding" v-for="(item, index) in displayedSlides" :key="index">
					<div class="border-0">
						<!-- <img class="card-img-top" :src="item.url" alt="Card image cap"> -->
						<img class="card-img-top" v-if="item.isImage" :src="item.url" alt="Card image" loading="lazy" 
							style="max-height: 15rem;">
						<video class="card-img-top" :src="item.url" v-if="item.isVideo" style="max-height: 15rem;" preload="none" controls
							autoplay loop></video>
						<div class="card-body" style="text-align: left;padding:0.5rem 0">
							<h6 class="card-title">{{ item.title }}</h6>
							<p class="card-text">
								{{ item.date }}
							</p>
							<p class="card-text">
								{{ item.summary}}
							</p>
						</div>
					</div>
				</div>
			</div>
			<!-- 分页点 -->
			<div class="dots mt-4" v-if="slidesgroup>1">
				<span  v-for="(item, index) in slidesgroup" :key="index" 
					:class="['dot', { active: currentPage === index + 1 }]" @click="currentPage = index + 1"></span>
			</div>
		</section>

		<section class="container row pt-4" data-aos="fade-up" id="example-carousel">

			<div class="pb-4" style="text-align: left;flex: 1;">
				<h3 class="mt-4 custom-color-primary"> FOLLOW US</h3>
				<h3 class="mb-3 custom-color-primary">TO LEARN MORE</h3>
				<span class="text-muted">
					Feel free to follow us on our social media channels.<br>
					Then you can be sure to be the first to receive news and<br>
					activities.</span>
			</div>

			<div class="pb-4"
				style="text-align: right;display: flex;width: 280px;align-items:flex-end;margin-right:15px;">
				<!-- <div style="margin-right: 15px;">
					<img src="../../assets/img/Main/Instagram.png" @click="openNewWin(123)"
						style="width: 40px;height: 40px;">
				</div> -->
				<div style="margin-right: 15px;">
					<img src="/assets/img/Main/YouTuBe.png" @click="openNewWin(345)"
						style="width: 40px;height: 40px;">
				</div>
				<div style="margin-right: 15px;">
					<img src="/assets/img/Main/Facebook.png" @click="openNewWin('http://www.baidu.com')"
						style="width: 40px;height: 40px;">
				</div>
				<div style="margin-right: 15px;">
					<img src="/assets/img/Main/TikTok.png" @click="openNewWin('https://www.runoob.com/')"
						style="width: 40px;height: 40px;">
				</div>
				<div style="margin-right: 15px;">
					<img src="/assets/img/Main/LinkedIn.png" @click="openNewWin(555)"
						style="width: 40px;height: 40px;">

				</div>
			</div>
		</section>
	</main>
</template>

<script>
	import { getVlogTypeMain, getDataInfo } from "@/api/rbac/vlog";
	export default {
		data() {
			return {
				field: [
					// { img: "/assets/img/Main/OffRoad.png", title: "Off Road" },
					// { img: "/assets/img/Main/Emergency.png", title: "Emergency & Warning" },
					// { img: "/assets/img/Main/Truck.png", title: "Truck" },
					// { img: "/assets/img/Main/Agricultural.png", title: 'Agricultural' },
					// { img: "/assets/img/Main/Marine.png", title: "Marine" },
					// { img: "/assets/img/Main/Mining.png", title: "Mining" },
					// { img: "/assets/img/Main/FireTruck.png", title: "Fire Truck" },

				],
				slides: [
					{ img: "/assets/img/Main/video1.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/video2.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/image1.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/image1.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/image1.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/video2.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/video1.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },
					{ img: "/assets/img/Main/video2.png", title: "7304A Product Introduction", date: '2024-12-16', described: 'Certainly!If Youare looking for reliable and new LED solutions,there are several key factors and trends to consider...' },

				],
				currentPage: 1,  // 当前显示的页面
				itemsPerPage: 3,  // 每页显示3张图片
				listAllVlog: [],
				listCurrentVlog: [],
			};
		},
		computed: {
			slidesgroup() {
				return Math.ceil(this.listCurrentVlog.length / 3);
			},
			displayedSlides() {
				const start = (this.currentPage - 1) * this.itemsPerPage;
				const end = start + this.itemsPerPage;
				return this.listCurrentVlog.slice(start, end);
			}
		},
		created() {
			this.getVlogType()
			this.getVlogInfo()
		},
		methods: {
			openNewWin(aaa) {
				try {
					const newWindow = window.open(aaa, '_blank');
					if (!newWindow) {
						alert('您的浏览器可能阻止了弹出窗口。请允许并重试。');
					}
				} catch (error) {
					console.error('无法打开新标签页:', error);
				}
			},
			getVlogType() {
				try {
					getVlogTypeMain({ strWhere: ' and a.pID>0' }).then((res) => {
						this.field = res.data;
						this.field.forEach(element => {
							if (element.url) {
								element.url = '../../../assets/img/Vlog/' + element.url
							}
						});
					});
				} catch (error) {
					console.log(error);
				}
			},
			getVlogInfo() {
				try {
					const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
					const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mkv', ''];
					getDataInfo({ strType: 'vlog' }).then((res) => {
						// this.listAllVlog = res.data;
						// console.log(res.data)
						this.listAllVlog = [];
						let isImage = true
						let isVideo = false
						res.data.forEach(element => {


							// this.listAllVlog.forEach(element => {

							if (element.url) {
								// element.url = '../../../assets/img/Vlog/' + element.url

								const extension = element.url.split('.').pop().toLowerCase();
								element.url = '../../../assets/img/Vlog/' + element.url
								if (imageExtensions.includes(extension)) {
									isImage = true;
									isVideo = false;
								}
								if (videoExtensions.includes(extension)) {
									isImage = false;
									isVideo = true;
								}
							}
							var temVlog = { id: element.id, date: element.data, title: element.title, typeID: element.typeID, url: element.url, summery: element.summery, isImage: isImage, isVideo: isVideo }
							this.listAllVlog.push(temVlog);
						});
						if (this.listAllVlog.length > 0) {
							this.getVlogData(this.listAllVlog[0])
						}
					});

				} catch (error) {
					console.log(error);
				}
			},
			getVlogData(id) {
				this.currentPage=1;
				this.listCurrentVlog = [];
				this.listAllVlog.forEach(item => {
					if (item.typeID == id) {
						this.listCurrentVlog.push(item);
					}
				})
			},
		},
	};
</script>

<style scoped>
	@import '../../assets/css/main.css';

	:deep(.photo-group) {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
	}

	:deep(.photo-container) {
		text-align: center;
		position: relative;
		width: 10rem;
		height: 9rem;
		cursor: pointer;
		display: flex;
		justify-content: center;
	}

	@media (max-width: 576px) {
		:deep(.photo-container) {
			width: 10rem;
		}
	}

	:deep(.photo-title) {
		margin-top: 7rem;
		font-size: 14px;
		color: #9E9E9E;
	}

	@media (max-width: 1200px) {
		:deep(.photo-container:not(:last-child)::after) {
			width: 0px;
		}
	}

	:deep(.photo-container img) {
		position: absolute;
		top: 0;
		width: 6.5rem;
		object-fit: contain;
		transition: opacity 0.3s ease-in-out;
		/* 平滑的切换效果 */
	}

	:deep(.carousel) {
		position: relative;
		width: 100%;
		height: 300px;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	:deep(.carousel-wrapper) {
		position: relative;
		width: 360px;
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		perspective: 1000px;
	}

	:deep(.carousel-item) {
		position: absolute;
		width: 360px;
		height: 300px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
		transition: transform 0.5s ease, z-index 0.5s ease;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}

	:deep(.carousel-item img) {
		width: 100%;
		height: auto;
		border-radius: 10px;
	}

	:deep(.carousel-item p) {
		position: absolute;
		bottom: 10px;
		font-size: 14px;
		color: #333;
	}

	:deep(.control) {
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		font-size: 20px;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		border: none;
		cursor: pointer;
		padding: 0px 12px;
		border-radius: 50%;
		z-index: 20;
	}

	:deep(.control.left) {
		left: 10px;
	}

	:deep(.control.right) {
		right: 10px;
	}

	:deep(.control:hover) {
		background: rgba(0, 0, 0, 0.8);
	}

	:deep(.card-title) {
		margin-bottom: 0.2rem;
	}

	:deep(.card-body) {
		color: #9E9E9E
	}

	:deep(.card-text) {
		font-size: 14px;
	}

	@media (max-width: 768px) {
		:deep(.carousel-wrapper) {
			width: 90%;
		}

		:deep(.carousel-item) {
			max-width: 300px;
		}
	}

	:deep(.container .col-md-8) {
		display: ruby;
		text-align: right;
		position: fixed;
		bottom: 0px;
		right: 0px;
	}

	@media (max-width: 768px) {
		:deep(.container .col-md-8) {
			width: 100%;
			position: relative;
			text-align: left;
			margin-top: 12px;
		}
	}

	@media (max-width: 480px) {
		:deep(.carousel-wrapper) {
			width: 100%;
		}

		:deep(.control) {
			font-size: 15px;
			padding: 0px 9px;
		}
	}
</style>